var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFocusE(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 54,
    viewBox: "0 0 180 131",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 99.6812V3H177V99.6812H3ZM0 2C0 0.895432 0.895431 0 2 0H178C179.105 0 180 0.895431 180 2V100.681C180 101.786 179.105 102.681 178 102.681H93V127.087H109.565C110.394 127.087 111.065 127.759 111.065 128.587C111.065 129.415 110.394 130.087 109.565 130.087H70.4348C69.6064 130.087 68.9348 129.415 68.9348 128.587C68.9348 127.759 69.6064 127.087 70.4348 127.087H90V102.681H2.00001C0.895436 102.681 0 101.786 0 100.681V2ZM148.696 91.2319C147.315 91.2319 146.196 92.3512 146.196 93.7319C146.196 95.1126 147.315 96.2319 148.696 96.2319H172.174C173.555 96.2319 174.674 95.1126 174.674 93.7319C174.674 92.3512 173.555 91.2319 172.174 91.2319H148.696Z",
    fill: "url(#paint0_linear_100_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_100_2",
    x1: -20,
    y1: -6.5,
    x2: 194,
    y2: 133.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002D37"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusE);
export default __webpack_public_path__ + "static/media/focus-e.44a2436c2a94a0ed27753affc78d8641.svg";
export { ForwardRef as ReactComponent };